import {
  courseNameWithFallbacks,
  programNameWithFallbacks,
} from '@/utils/entityNames'

/*
Note: If a useCourse/useProgram composable file is ever written,
these functions can be moved to such a file
*/
function extractCourseLabels(course) {
  const code = course.code || `${course.subjectCode + course.courseNumber}`
  const name = courseNameWithFallbacks(course) || 'Untitled Course'
  return { code, name }
}

function generateCourseLabel(course, courseGroupId) {
  // if courseGroupId is provided and no course is found, return courseGroupId
  // otherwise fallback to 'Course Not Found' text
  if (!course) return courseGroupId || 'Course Not Found'
  if (!course) return 'Course Not Found'
  const { code, name } = extractCourseLabels(course)
  return code ? `${code} - ${name}` : name
}

function extractCourseCredits(course) {
  if (!course) return { min: undefined, max: undefined }

  let min = 0
  let max = 0
  if (course.credits?.creditHours?.min) {
    min = course.credits.creditHours.min
  }
  if (course.credits?.creditHours?.max) {
    max = course.credits.creditHours.max
  }

  return { min, max }
}

function generateCourseCreditsRange(course) {
  if (!course) return ''

  const { min, max } = extractCourseCredits(course)

  if (!min && !max) return ``
  if (!max && min) return `(${min} Cr.)`
  if (!min && max) return `(${max} Cr.)`
  return min === max ? `(${min} Cr.)` : `(${min} - ${max} Cr.)`
}

function extractProgramLabels(program) {
  const code = program.code
  const name = programNameWithFallbacks(program) || 'Untitled Program'
  return { code, name }
}

function generateProgramLabel(program, school) {
  if (!program) return 'Program Not Found'
  const { code, name } = extractProgramLabels(program)
  switch (school) {
    case 'scsu':
      return name
    case 'hpu':
      return name
    default:
      return code ? `${code} - ${name}` : name
  }
}

export {
  extractCourseLabels,
  generateCourseLabel,
  extractCourseCredits,
  generateCourseCreditsRange,
  extractProgramLabels,
  generateProgramLabel,
}
